<footer class="chunk border-t border-brand-grid/40 bg-brand-surface/60 backdrop-blur">
    <div class="mx-auto flex max-w-6xl flex-col gap-8 px-4 py-12 text-sm text-brand-muted md:flex-row md:items-start md:justify-between lg:px-8">
        <div class="max-w-sm space-y-3">
            <p class="font-sans text-brand-ice">
                {{ terms['footer-community-label'] ?? 'HBARiot is a community-led rebellion building resilient Hedera infrastructure.' }}
            </p>
            <a class="inline-flex items-center gap-2 text-brand-glow transition-colors hover:text-brand-flare" [href]="exploreChainHref || externalLinks[0].href" target="_blank" rel="noopener noreferrer">
                {{ terms['footer-explore-chain'] ?? 'Explore the chain' }}
            </a>
            <p class="text-xs text-brand-grid">
                {{ terms['footer-rights'] ?? 'All rights reserved.' }}
            </p>
        </div>
        <nav class="grid gap-6 sm:grid-cols-2 md:grid-cols-1">
            <div>
                <h2 class="font-semibold uppercase tracking-[0.3em] text-brand-ice">
                    {{ terms['footer-nav-title'] ?? 'Navigation' }}
                </h2>
                <ul class="mt-3 space-y-2">
                    <li *ngFor="let link of navLinks">
                        <a [routerLink]="link.href" class="transition-colors hover:text-brand-glow">
                            {{ terms[link.labelKey] ?? link.labelKey }}
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                <h2 class="font-semibold uppercase tracking-[0.3em] text-brand-ice">
                    {{ terms['footer-social-title'] ?? 'Connect' }}
                </h2>
                <ul class="mt-3 space-y-2">
                    <li *ngFor="let link of externalLinks">
                        <a [href]="link.resolvedHref || link.href" [attr.target]="link.external ? '_blank' : null" [attr.rel]="link.external ? 'noopener noreferrer' : null" class="transition-colors hover:text-brand-glow">
                            {{ terms[link.labelKey] ?? link.labelKey }}
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="space-y-3 text-xs text-brand-grid">
            <p>{{ terms['footer-version'] ?? 'Site version 0.1.0' }}</p>
            <a href="https://github.com/HBARiot" target="_blank" rel="noopener noreferrer" class="transition-colors hover:text-brand-glow">
                {{ terms['footer-code'] ?? 'Open-source efforts on GitHub' }}
            </a>
        </div>
    </div>
</footer>
